import { createFileRoute, Link } from "@tanstack/react-router";
import { RefreshCw, ListChecks, Users, ScrollText } from "lucide-react";

export const Route = createFileRoute("/_authenticated/admin/")({
  component: AdminHome,
});

function AdminHome() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-serif text-2xl font-semibold text-primary sm:text-3xl">
          Painel administrativo
        </h1>
        <p className="mt-1 text-sm text-muted-foreground sm:text-base">
          Gerencie o catálogo de ensinos e membros da plataforma.
        </p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4">
        {[
          {
            to: "/admin/sincronizar",
            icon: RefreshCw,
            title: "Sincronizar YouTube",
            desc: "Importar novos vídeos do canal @rechovot.",
          },
          {
            to: "/admin/ensinos",
            icon: ListChecks,
            title: "Ensinos",
            desc: "Ver e remover ensinos do catálogo.",
          },
          {
            to: "/admin/membros",
            icon: Users,
            title: "Membros",
            desc: "Ver membros e conceder acesso admin.",
          },
          {
            to: "/admin/logs",
            icon: ScrollText,
            title: "Logs de atividade",
            desc: "Ações de usuários, e-mails, sincronizações e erros.",
          },
        ].map(({ to, icon: Icon, title, desc }) => (
          <Link
            key={to}
            to={to as any}
            className="group relative rounded-xl border border-border bg-card p-5 transition-all hover:border-primary/40 hover:shadow-md"
          >
            <Icon className="h-6 w-6 text-primary" />

            <h2 className="mt-3 font-serif text-lg font-semibold text-foreground group-hover:text-primary">
              {title}
            </h2>
            <p className="mt-1 text-sm text-muted-foreground">{desc}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
